module.exports = __webpack_public_path__ + "img/logo_copy.9fc5d68a.png";